import { AppDataController } from '../services/appData/controller'
import { TransactionController } from '../services/transaction/controller'
import { UserController } from '../services/user/controller'
import { Events } from '../utils/servicesEvents'
import { ServicesVars } from '../utils/servicesVars'
import { AppNotificationController } from '../services/appNotification/controller'
import { Network } from '../utils/network'

let listenersEnabled = false
let periodicOperationsEnabled = false

function initListeners() {
  if (listenersEnabled) return
  ServicesVars.init()
  Events.initListeners()
  UserController.initListeners()
  AppDataController.initListeners()
  TransactionController.initListeners()
  AppNotificationController.initListeners()
  Network.initListenerForServiceWorker()
  listenersEnabled = true
}

function initPeriodicOperations() {
  if (periodicOperationsEnabled) return
  // AppDataController.downloadUserData()
  // setInterval(() => {
  //   AppDataController.downloadUserData()
  // }, 60000)
  periodicOperationsEnabled = true
}

function initServices() {
  console.log('will init services')
  initListeners()
  initPeriodicOperations()
  UserController.refreshData()
  AppDataController.downloadRequirements()
  TransactionController.downloadData()
}

class WorkerProcess {
  static initServiceWorkerListener() {
    self.addEventListener('install', event => {
      self.skipWaiting()
    })

    self.addEventListener('activate', () => {
      clients.claim()
      initServices()
      Events.dispatchEvent('worker_activated')
    })
  }

  static initEventsListener() {
    Events.handleEvent('service_worker_ready', initServices)
    Events.handleEvent('registration_done', initServices)
    Events.handleEvent('login_done', initServices)
  }

  static initServices() {
    initServices()
  }
}
export { WorkerProcess }
